module.exports = __webpack_public_path__ + "img/logo.6e0710e1.svg";